import { 
  dimensionMonthlyMetricsTrend,
  dimensionMonthlyMetricsTrendXh,
  downLoadMonthlyPerformanceTable,
  downLoadMonthlyPerformanceTableXh,
  getMonthMetricsUsers,
  getMonthMetricsUsersXh,
  getMonthRegionCountriesZone,
  getMonthRegionCountriesZoneXh,
  getMonthlyKeyPerformanceMetrics, 
  getMonthlyKeyPerformanceMetricsXh, 
  getMonthlyPerformanceTable, 
  getMonthlyPerformanceTableXh,
  loadMonthlyMetricsTrend,
  loadMonthlyMetricsTrendXh
} from "@/pages/dashboard/services/overview"

export const COMPETITOR_REQ_TYPE = {
  "monthly": "normal",
  "xh-monthly": "xh",
}

type ReqType = keyof typeof COMPETITOR_REQ_TYPE; // Define a type for the keys

// Function to get the value for a key with a default fallback
export const getReqType = (key: string): string => {
  if (key in COMPETITOR_REQ_TYPE) {
    return COMPETITOR_REQ_TYPE[key as ReqType];
  } else {
    // Get the value of the first key in COMPETITOR_REQ_TYPE
    const firstKey = Object.keys(COMPETITOR_REQ_TYPE)[0] as ReqType;
    return COMPETITOR_REQ_TYPE[firstKey];
  }
};

export const LOG_PAGE_ID = {
  normal: "200301",
  xh: "203901",
}

type LogPageIdType = keyof typeof LOG_PAGE_ID; // Define a type for the keys

// Function to get the value for a key with a default fallback
export const getPageId = (key: string): string => {
  if (key in LOG_PAGE_ID) {
    return LOG_PAGE_ID[key as LogPageIdType];
  } else {
    // Get the value of the first key in LOG_PAGE_ID
    const firstKey = Object.keys(LOG_PAGE_ID)[0] as LogPageIdType;
    return LOG_PAGE_ID[firstKey];
  }
};

export const overviewMonthlyRequest: any = {
  getMonthlyKeyPerformanceMetrics: {
    normal: getMonthlyKeyPerformanceMetrics,
    xh: getMonthlyKeyPerformanceMetricsXh,
  },
  loadMonthlyMetricsTrend: {
    normal: loadMonthlyMetricsTrend,
    xh: loadMonthlyMetricsTrendXh,
  },
  dimensionMonthlyMetricsTrend: {
    normal: dimensionMonthlyMetricsTrend,
    xh: dimensionMonthlyMetricsTrendXh,
  },
  getMonthlyPerformanceTable: {
    normal: getMonthlyPerformanceTable,
    xh: getMonthlyPerformanceTableXh,
  },
  downLoadMonthlyPerformanceTable: {
    normal: downLoadMonthlyPerformanceTable,
    xh: downLoadMonthlyPerformanceTableXh,
  },
  getMonthMetricsUsers: {
    normal: getMonthMetricsUsers,
    xh: getMonthMetricsUsersXh,
  },
  getMonthRegionCountriesZone: {
    normal: getMonthRegionCountriesZone,
    xh: getMonthRegionCountriesZoneXh,
  }
}
